<template>
  <section class="root">
    <p class="section-title">
      <img src="@/assets/shisetsu.svg" />
      施設情報
    </p>
    <ul>
      <li v-if="spotData.address">
        {{ spotData.address.replace("日本、", "") }}
      </li>
      <li
        @click="changeWeekDayOpenStatus"
        v-if="spotData.business_hours && selectedSpotParsedBusinessHours"
      >
        <div class="hour">
          <div class="openstatus">
            <img v-show="!isWeekdayOpen" src="@/assets/chevron.svg" />
            <img
              v-show="isWeekdayOpen"
              class="isExpand"
              src="@/assets/chevron-green.svg"
            />
          </div>
          <p
            class="item target"
            :class="{ isExpand: isWeekdayOpen }"
            v-for="item in selectedSpotParsedBusinessHours"
            v-if="contain(item, selectedDay)"
            :key="item"
          >
            {{ item }}
          </p>
          <p
            class="item"
            v-for="item in selectedSpotParsedBusinessHours"
            :key="`${item}-2`"
            v-if="isWeekdayOpen && !contain(item, selectedDay)"
          >
            {{ item }}
          </p>
        </div>
      </li>
      <li v-if="spotData.tel" class="phoneWrapper">
        {{ spotData.tel }}
        <a class="phone" :href="`tel:${spotData.tel}`">
          <img src="@/assets/phone.svg" />
        </a>
      </li>
      <li v-if="spotData.home_page_url">
        <a :href="spotData.home_page_url" target="_blank">{{
          spotData.home_page_url
        }}</a>
      </li>
    </ul>
    <template v-if="spotData.comment">
      <p class="section-title osusume">
        <img src="@/assets/comment.svg" />
        おすすめポイント
      </p>
      <p class="osusumeDescription" v-html="spotData.comment" />
    </template>
  </section>
</template>

<script>
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "show-review-area",
  components: {
    ButtonTextLink,
  },
  props: {
    spotData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      selectedDay: "日",
      isWeekdayOpen: false,
    };
  },
  computed: {
    weekdayList() {
      return [
        "日曜日",
        "月曜日",
        "火曜日",
        "水曜日",
        "木曜日",
        "金曜日",
        "土曜日",
      ];
    },
    selectedSpotParsedBusinessHours() {
      const data = this.spotData;
      if (data.business_hours === null) return [];
      let results = null;
      if (data && data.business_hours != null) {
        const quoteSplit = data.business_hours.split(",");
        if (quoteSplit.length > 1) {
          for (let i = 0; i < quoteSplit.length; i++) {
            const quateItem = quoteSplit[i];
            if (quateItem.match("[月火水木金土日]曜日")) {
              if (!results) {
                results = [];
              }
              results.push(quateItem);
            }
          }
        }
      }
      return results;
    },
  },
  methods: {
    contain(target, findText) {
      return target.indexOf(findText) !== -1;
    },
    changeWeekDayOpenStatus() {
      this.isWeekdayOpen = !this.isWeekdayOpen;
    },
  },
  mounted() {
    var date = new Date();
    var dayOfWeek = date.getDay();
    var dayOfWeekStr = this.weekdayList[dayOfWeek];
    this.selectedDay = dayOfWeekStr;
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.root {
  padding: 0 1.25rem;
  .section-title {
    display: flex;
    align-items: center;
    margin: 0.5rem 0;
    img {
      margin-right: 0.5rem;
      width: 20px;
    }
    p {
      line-height: 20px;
    }
  }

  .hour {
    position: relative;
    display: flex;
    flex-direction: column;
    .item {
      display: inline-flex;
      margin: 0.1rem 0;
    }
    .target {
      &.isExpand {
        color: #5cd5d6;
      }
    }
    .openstatus {
      position: absolute;
      right: 0.5rem;
      img {
        width: 0.6rem;
      }
      .isExpand {
        transform: rotate(180deg);
      }
    }
  }
  ul {
    list-style: none;
    padding-left: 0;
    border-bottom: 1px #e7e7e7 solid;
    margin: 0.5rem 0;
    li {
      font-size: 1rem;
      margin: 0;
      padding: 1rem 0.5rem;
      border-top: #e7e7e7 1px solid;
    }
  }
  .phoneWrapper {
    position: relative;
    display: flex;
    align-items: center;

    .phone {
      position: absolute;
      right: 0.5rem;
      padding: 0.25rem;
      border: 0.5px #ccc solid;
      justify-content: center;
      display: inline-flex;
      align-items: center;
      border-radius: 50%;
      img {
        width: 1rem;
      }
    }
  }
  .osusume {
    margin-top: 2rem;
  }
  .osusumeDescription {
    white-space: pre-wrap;
  }

  a,
  a:visited,
  a:hover,
  a:active {
    color: #5cd5d6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelectModal/SpotInfo.vue